import isMobile from './utils/isMobile';
import isMobileDevice from './utils/isMobileDevice';
import objectFit from './modules/object-fit';
import navClick from './modules/navClick';
import navClose from './modules/navClose';
import scrollTop from './modules/scroll-to-top';

window.addEventListener('load', function ()
{
    navClick();
    navClose();
    objectFit();
    scrollTop();
});
